import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { DealConfigurationQuery } from '../../../../../generated/graphql'
import { distinctUntilChanged, map, pluck } from 'rxjs/operators'
import { DealQueryService } from 'modules/deals/services/dealQuery.service'

@Injectable({
    providedIn: 'root',
})
export class ConfigurationStateService {
    constructor(private dealQueryService: DealQueryService) {}

    getHasBeenApproved(id): Observable<boolean> {
        return this.dealQueryService.watchDealConfiguration(id).pipe(
            pluck<DealConfigurationQuery['Deal'], string>('status'),
            map<string, boolean>((status: string) => ['email_sent', 'approved'].indexOf(status) !== -1),
            distinctUntilChanged()
        )
    }
}
